export function toQueryString(
  params: Record<string, string | number | boolean | undefined> | undefined
): string {
  return params
    ? Object.keys(params)
        .filter(function (k) {
          return params[k] != null
        })
        .map(function (k) {
          return (
            k + '=' + encodeURIComponent(params[k] as string | number | boolean)
          )
        })
        .join('&')
    : ''
}
